module.exports = __webpack_public_path__ + "assets/ewm-weibo.e355a399.jpg";